import * as types from '../constants/actionTypes';
import { PENDING, FULFILLED, REJECTED } from 'redux-promise-middleware';

const contactReducerInitialState = {
  isFetching: false,
  data: null,
  error: null,
};

const contactReducer = (state = contactReducerInitialState, action) => {
  switch (action.type) {
    case types.SEND_EMAIL + '_' + PENDING:
      return { ...state,
        isFetching: true,
        data: null,
        error: null,
      };
    case types.SEND_EMAIL + '_' + FULFILLED:
      return { ...state,
        isFetching: false,
        data: action.payload.data,
        error: null,
      };
    case types.SEND_EMAIL + '_' + REJECTED:
      return { ...state,
        isFetching: false,
        data: null,
        error: action.payload.error,
      };
    default:
      return state;
  }
};

export default contactReducer;



// WEBPACK FOOTER //
// ./src/reducers/contactReducer.js